import { SetupAuth } from "../../client";

const sourceParam = (isInForce?: boolean) => (isInForce ? "force" : "rc");

export const getSkillId = async (
  skillIdForm: string,
  authorization: string,
  ambient: string,
  setSkillName: React.Dispatch<React.SetStateAction<string>>,
  isInForce?: boolean,
) => {
  try {
    if (skillIdForm === "") return;
    const apiClient = SetupAuth(authorization);
    const source = sourceParam(isInForce);
    const response = await apiClient.get(
      `/get-skill?skillId=${skillIdForm}&ambient=${ambient}&source=${source}`,
    );
    setSkillName(response.data.name);
    return response.data;
  } catch {
    return;
  }
};
